// import PropTypes from 'prop-types';
import s from './ExpandView.module.scss';
import Icon from '../Icon/Icon';
import { useSidebar } from '../../utils/sidebar-provider';

const ExpandView = () => {
    const { isSidebarShown, toggleSidebar } = useSidebar();

    return (
        <button type="button" className={s.Root} onClick={toggleSidebar}>
            <div className={s.TextWrapper}>
                <Icon name={isSidebarShown ? 'Expand' : 'OpenMenu'} />
                {isSidebarShown ? 'Expand' : 'Show menu'}
            </div>
        </button>
    );
};

ExpandView.propTypes = {};

export default ExpandView;
